import type { SelectOption } from '@aus-platform/design-system';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import type { SiteListItem } from '../../shared/api';
import { refetchDashboardKPIs } from '../helpers';
import { initialDashboardDatasetState } from './constants';

export const dashboardDatasetSlice = createSlice({
  name: 'dashboardDatasetSlice',
  initialState: initialDashboardDatasetState,
  reducers: {
    setProject: (state, action: PayloadAction<SelectOption>) => {
      Object.assign(state, {
        project: action.payload,
        site: null,
      });
    },

    setSite: (state, action: PayloadAction<SelectOption<SiteListItem>>) => {
      Object.assign(state, { site: action.payload });
    },

    setUserSiteManagePermission: (state, action: PayloadAction<boolean>) => {
      Object.assign(state, { userHasManageSitePermission: action.payload });
    },

    resetDataset: (state) => {
      Object.assign(state, initialDashboardDatasetState);
    },

    refetchKPIs: refetchDashboardKPIs,
  },
});

// Actions.
export const {
  setProject,
  setSite,
  setUserSiteManagePermission,
  resetDataset,
  refetchKPIs,
} = dashboardDatasetSlice.actions;

// Selector.
export const selectDashboardDataset = (state: RootState) =>
  state.dashboard.dashboardDataset;

//  Reducer.
export const dashboardDatasetReducer = dashboardDatasetSlice.reducer;
